/* eslint-disable no-undef */
import Vue from 'vue';
import Vuex from 'vuex';
import { isWechatMiniProgram } from '@utils';
import { wxConfig } from '@api';
import queryString from 'query-string';

Vue.use(Vuex);

export function createStore() {
  return new Vuex.Store({
    state: {
      channelId: '',
      s: '',
      platform: '',
      urlQuery: {},
      advInfo: {
        // 第三方埋点信息  腾讯/ 字节
        channel: '',
        clickId: ''
      },

      env: '', // 所处宿主环境

      couponHasSend: 0, // 标识用户是否已领取过优惠券（0:未领券 1：已领券）
      currentStatus: 'home', // home success fail

      loginFlag: false, // 登录框开关
      ruleFlag: false, // 规则框开关

      city_name: '', // 城市名
      lat: '', // 经度
      lng: '', // 纬度

      // 活动基础配置
      baseInfo: {
        title: '',
        name: ''
      },

      // 微信配置
      wechatInfo: {
        title: '',
        desc: '',
        isShare: false,
        appMessageImgUrl: '',
        TimelineImgUrl: '',
        miniImgUrl: ''
      },

      // 首页
      indexInfo: {
        banner: '',
        theme: '',
        bg: '',
        ruleColor: '',
        ruleBg: '',
        couponImg: '',
        couponBg: '',
        btnShadow: '',
        btnColor: '',
        btnCon: '',
        footList: []
      },

      // 新人领券
      newSuccessInfo: {
        couponList: [],
        hasBtn: false,
        btnCon: '',
        hasTab: false,
        btnLink: '',
        otherList: []
      },

      // 老人领券
      oldSuccessInfo: {
        couponList: [],
        hasBtn: false,
        btnCon: '',
        hasTab: false,
        btnLink: '',
        otherList: []
      },

      // 失败领券
      failInfo: {
        failImg: '',
        hasBtn: false,
        btnCon: '',
        btnLink: '',
        otherList: []
      },

      // 活动规则
      ruleInfo: {
        ruleList: []
      },
      // 港版信息
      jsonRules: {},
      lang: '' //语言类型
    },
    actions: {
      // 服务端渲染配置
      render({ commit }, config) {
        commit('setState', { ...config });
      },

      // 微信初始化
      wechatInit({ commit, dispatch }) {
        isWechatMiniProgram().then(
          res => {
            commit('setState', {
              env: res ? '微信小程序' : '微信浏览器'
            });
            wxConfig()
              .then(() => {
                dispatch('initShare');
                // dispatch('wechatGwechatGetLocation');
              })
              .catch(error => {
                console.log('config错误', error);
              });
          },
          () => {
            commit('setState', {
              env: '非微信环境'
            });
          }
        );
      },

      // 2. 微信定位
      wechatGwechatGetLocation({ state, commit }, callback) {
        // eslint-disable-next-line no-undef
        if (state.env === '非微信环境') {
          commit('setState', {
            city_name: ''
          });

          if (callback) {
            callback();
          }
          return;
        }
        wx.getLocation({
          success: function(res) {
            console.log('微信定位成功', res);
            commit('setState', {
              lat: String(res.latitude), // 经度
              lng: String(res.longitude)
            });
            const geocoder = new AMap.Geocoder({
              city: '全国',
              radius: 1000
            });
            geocoder.getAddress([state.lng, state.lat], function(status, result) {
              if (status === 'complete' && result.regeocode) {
                commit('setState', {
                  city_name:
                    result.regeocode.addressComponent.city ||
                    result.regeocode.addressComponent.province
                });
              } else {
                commit('setState', {
                  city_name: ''
                });
              }
              if (callback) {
                callback();
              }
            });
          },
          fail: function(res) {
            console.log('微信定位失败', res);
            commit('setState', {
              city_name: ''
            });
            if (callback) {
              callback();
            }
          },
          cancel: function() {
            console.log('用户拒绝授权获取地理位置');
            commit('setState', {
              city_name: ''
            });
            if (callback) {
              callback();
            }
          }
        });
      },

      // 微信分享
      initShare({ state }) {
        const {
          title,
          desc,
          appMessageImgUrl,
          TimelineImgUrl,
          miniImgUrl,
          isShare
        } = state.wechatInfo;
        if (isShare) {
          // 分享的链接去掉envPlatform token #号
          let p = queryString.parse(window.location.search.slice(1));
          if (p.envPlatform) delete p.envPlatform;
          if (p.token) delete p.token;
          if (p.state) delete p.state;
          if (p.code) delete p.code;
          let shareUrl = `${location.origin}${location.pathname}?${queryString.stringify(p)}`;
          console.log(shareUrl, shareUrl);
          // 分享微信好友
          wx.updateAppMessageShareData({
            title,
            desc,
            link: shareUrl,
            imgUrl: appMessageImgUrl // 分享图标
          });

          // 分享微信朋友圈
          wx.updateTimelineShareData({
            title,
            desc,
            link: shareUrl,
            imgUrl: TimelineImgUrl
          });

          // 微信小程序分享
          if (state.env === '微信小程序') {
            wx.miniProgram.postMessage({
              data: {
                title,
                desc,
                link: shareUrl,
                imgUrl: miniImgUrl
              }
            });
          }
        } else {
          wx.hideMenuItems({
            menuList: [
              'menuItem:share:appMessage',
              'menuItem:share:timeline',
              'menuItem:share:qq',
              'menuItem:share:weiboApp',
              'menuItem:share:facebook',
              'menuItem:share:QZone'
            ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
          });
        }
      }
    },

    mutations: {
      setState(state, payload) {
        Object.keys(payload).forEach(key => {
          state[key] = payload[key];
        });
      }
    }
  });
}
